module.exports = __webpack_public_path__ + "static/Grafika9@2x-56f2fe29d322393a1541121c3808c224.png";